// extracted by mini-css-extract-plugin
module.exports = {"texts":"SaleSupplierInvoiceDetailsLabels_texts__tb39W","second-label":"SaleSupplierInvoiceDetailsLabels_second-label__g1W8z"};